import { LogoMark } from "@/components/agent/AgentLayout";

export const Logo = () => (
  <span className="inline-flex items-center gap-2" data-testid="ref-logo">
    <LogoMark />
    <span className="text-sm font-semibold text-foreground">Landin</span>
  </span>
);
